import { detect } from 'detect-browser'

const browser = detect()

if (browser.name === 'ie' && browser.version.split('.')[0] !== '11') {
  console.warn('Browser not support')
} else {
  const chat = document.createElement('script')

  chat.setAttribute('src',`$\{assets_path}/ccp-widget/widget.js?t=${process.env.DEPLOY_TIME}`)

  document.head.appendChild(chat)
}
